<template>
  <div class="collapse">
    <div class="flex-between">
      <h3 class="collapse-title">注意事项</h3>
      <a class="collapse-btn" @click="onCollapse">收起/展开</a>
    </div>
    <div
      :style="{
        height: isCollapse ? '130px' : 'auto',
        overflow: isCollapse ? 'hidden' : 'auto'
      }"
      v-html="data"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isCollapse: true
    }
  },
  methods: {
    onCollapse() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
}
.collapse {
  position: relative;
  padding: 20px;
  border: 1px solid #e8e8e8;
  margin: 20px 0;
  .collapse-title {
    font-weight: 600;
    font-size: 14px;
  }
  .collapse-btn {
    font-size: 14px;
  }
}
</style>
